import { FC } from 'react';

export const NoResultForFilter: FC = () => (
  <div className="no-results">No Results for the Current Filter(s)</div>
);
